export const CERTTYPE_CREATED_REQUESTED = 'CERTTYPE_CREATED_REQUESTED';
export const CERTTYPE_CREATED_SUCCEED = 'CERTTYPE_CREATED_SUCCEED';
export const CERTTYPE_CREATED_FAILED = 'CERTTYPE_CREATED_FAILED';

export const CERTTYPE_GOT_REQUESTED = 'CERTTYPE_GOT_REQUESTED';
export const CERTTYPE_GOT_SUCCEED = 'CERTTYPE_GOT_SUCCEED';
export const CERTTYPE_GOT_FAILED = 'CERTTYPE_GOT_FAILED';

export const CERTTYPE_UPDATED_REQUESTED = 'CERTTYPE_UPDATED_REQUESTED';
export const CERTTYPE_UPDATED_SUCCEED = 'CERTTYPE_UPDATED_SUCCEED';
export const CERTTYPE_UPDATED_FAILED = 'CERTTYPE_UPDATED_FAILED';

export const CERTTYPE_DELETED_REQUESTED = 'CERTTYPE_DELETED_REQUESTED';
export const CERTTYPE_DELETED_SUCCEED = 'CERTTYPE_DELETED_SUCCEED';
export const CERTTYPE_DELETED_FAILED = 'CERTTYPE_DELETED_FAILED';

export const MINIMUM_FEE_GOT_REQUESTED = 'MINIMUM_FEE_GOT_REQUESTED';
export const MINIMUM_FEE_GOT_SUCCEED = 'MINIMUM_FEE_GOT_SUCCEED';
export const MINIMUM_FEE_GOT_FAILED = 'MINIMUM_FEE_GOT_FAILED';

export const CERT_FEE_GOT_REQUESTED = 'CERT_FEE_GOT_REQUESTED';
export const CERT_FEE_GOT_SUCCEED = 'CERT_FEE_GOT_SUCCEED';
export const CERT_FEE_GOT_FAILED = 'CERT_FEE_GOT_FAILED';

export const CERT_FEE_UPDATED_REQUESTED = 'CERT_FEE_UPDATED_REQUESTED';
export const CERT_FEE_UPDATED_SUCCEED = 'CERT_FEE_UPDATED_SUCCEED';
export const CERT_FEE_UPDATED_FAILED = 'CERT_FEE_UPDATED_FAILED';
